import { ADD_ASSIGNED_USER_TO_USER_TASK, CHANGE_USER_TASK_DONE_STATUS, EDIT_USER_TASK, REMOVE_ASSIGNED_USER_FROM_USER_TASK, REMOVE_USER_TASK, SET_USER_TASKS, SET_USER_TASKS_FILTERED_PIPELINE, SET_USER_TASKS_SEARCH_VALUE, } from "../constants";
import { convertTaskFromServer } from "../utils/task";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USER_TASKS: {
            const payload = action.payload;
            const tasks = payload.map(convertTaskFromServer);
            return Object.assign(Object.assign({}, state), { tasks });
        }
        case REMOVE_USER_TASK: {
            const taskId = action.payload;
            return Object.assign(Object.assign({}, state), { tasks: state.tasks.filter((task) => task.id !== taskId) });
        }
        case EDIT_USER_TASK: {
            const task = action.payload;
            const updatedTasks = state.tasks.map((t) => {
                if (t.id === task.id) {
                    return convertTaskFromServer(task);
                }
                return t;
            });
            return Object.assign(Object.assign({}, state), { tasks: updatedTasks });
        }
        case SET_USER_TASKS_SEARCH_VALUE: {
            const searchValue = action.payload;
            return Object.assign(Object.assign({}, state), { searchValue });
        }
        case SET_USER_TASKS_FILTERED_PIPELINE: {
            const filteredPipelineId = action.payload;
            return Object.assign(Object.assign({}, state), { filteredPipelineId });
        }
        case ADD_ASSIGNED_USER_TO_USER_TASK: {
            const { taskId, user } = action.payload;
            const updatedTasks = state.tasks.map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { assigned_users: [user, ...task.assigned_users] });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { tasks: updatedTasks });
        }
        case REMOVE_ASSIGNED_USER_FROM_USER_TASK: {
            const { taskId, user } = action.payload;
            const updatedTasks = state.tasks.map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { assigned_users: task.assigned_users.filter((assignedUser) => assignedUser.id !== user.id) });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { tasks: updatedTasks });
        }
        case CHANGE_USER_TASK_DONE_STATUS: {
            const { taskId, done } = action.payload;
            const updatedTasks = state.tasks.map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { is_done: done });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { tasks: updatedTasks });
        }
        default:
            return state;
    }
};
export { reducer };
